import React from "react";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { useTheme } from "arkh";
import { KPIEditParamList } from "./KPIEditParamList";
import { KPIEditMain } from "./KPIEditMain/KPIEditMain";
import { KPIEditSections } from "./KPIAdminEditSections/KPIEditSections";
import { KPIEditFrequencyScreen } from "./KPIEditFrequency";
import { UserLoggedInNavigatorParamList } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { HeaderButton } from "../../../components";
import { KPIEditTitle } from "./KPIEditTitle";
import { useIntl } from "react-intl";
import { KPIEditAdminTeam } from "./KPIEditAdminTeam";
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import { KPIEditUnit } from "./KPIEditUnit";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { PortalHost } from "@gorhom/portal";
import { AbsolutePopoverHostName } from "../../../components/mobile/AbsolutePopover";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";

const KPIAdminStack = createNativeStackNavigator<KPIEditParamList>();

export const KPIEdit = withWebModal(KPIEditC);
function KPIEditC(props: {
  navigation: NativeStackNavigationProp<
    UserLoggedInNavigatorParamList,
    "KPIEdit"
  >;
}) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const getHeader = useNavigationHeaderOptions();
  const theme = useTheme();
  return (
    <BottomSheetModalProvider>
      <KPIAdminStack.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: theme.background,
          },
        }}
      >
        <KPIAdminStack.Screen
          name="KPIEditMain"
          component={KPIEditMain}
          options={({ navigation }) =>
            getHeader({
              type: "CLOSE",
              onClose: () => navigation.goBack(),
              headerTitle: intl_tokens.EditKPI,
              defaultContentStyle: true,
            })
          }
        />
        <KPIAdminStack.Screen
          name="KPIEditUnit"
          component={KPIEditUnit}
          options={(p) => ({
            title: p.route.params.title,
          })}
        />
        <KPIAdminStack.Screen
          name="KPIEditTitle"
          component={KPIEditTitle}
          options={(p) => ({
            title: intl.formatMessage({
              defaultMessage: "KPI name",
              description: "KPIAdminEditTitle header title",
            }),
            headerTitleAlign: "center",
            headerLeft: () => (
              <HeaderButton type="CANCEL-BACK" onPress={p.navigation.goBack} />
            ),
          })}
        />
        <KPIAdminStack.Screen
          name="KPIEditFrequency"
          options={(p) => ({
            title: p.route.params.title,
          })}
          component={KPIEditFrequencyScreen}
        />
        <KPIAdminStack.Screen
          name="KPIEditSections"
          options={(p) => ({
            title: p.route.params.title,
          })}
          component={KPIEditSections}
        />
        <KPIAdminStack.Screen
          name="KPIEditAdminTeam"
          options={(p) => ({
            title: p.route.params.title,
          })}
          component={KPIEditAdminTeam}
        />
      </KPIAdminStack.Navigator>
      <PortalHost name={AbsolutePopoverHostName} />
    </BottomSheetModalProvider>
  );
}
